<template>
  <section class="section section__grid">
    <img :src="content.image" alt="" />
    <div class="section__half">
      <img :src="content.logo" alt="" class="section__logo" />
      <h2>{{ content.title }}</h2>
      <p class="paragraph mt-16">{{ content.description }}</p>
      <button class="button mt-30" @click.stop="content.action">
        {{ content.button }}
      </button>
    </div>
  </section>
</template>

<script>
export default {
  name: 'SplitSection',
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
}
</script>
